// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --primary-color: #4caf50;
    --primary-hover: #4caf50;
  --secondary-color: #10b981;
  --background-color: #111827;
  --surface-color: #1f2937;
  --text-color: #f3f4f6;
  --text-color-secondary: #9ca3af;
  --error-color: #ef4444;
  --success-color: #10b981;
  --warning-color: #f59e0b;
  --sidebar-width: 225px;
  --sidebar-collapsed-width: 70px;
  --header-height: 60px;
  --border-radius: 8px;
  --transition-speed: 0.3s;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Poppins', sans-serif;
  background-color: var(--background-color);
  color: var(--text-color);
  line-height: 1.6;
}

.dashboard {
  display: flex;
  min-height: 100vh;
}

.sidebar {
  width: var(--sidebar-width);
  background-color: var(--surface-color);
  transition: width var(--transition-speed) ease;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}

.sidebar-closed .sidebar {
  width: var(--sidebar-collapsed-width);
}

.sidebar-header {
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.avatar {
  width: 40px;
  height: 40px;
  background-color: var(--primary-color);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
}

.user-info {
  margin-left: 1rem;
}

.user-info h3 {
  font-size: 0.9rem;
  font-weight: 600;
}

.user-info p {
    font-size: 0.8rem;
    color: var(--text-color-secondary);
    color: #4CAF50;
}

.sidebar-toggle {
  position: fixed;
  top: 1rem;
  left: var(--sidebar-width);
  z-index: 1001;
  background-color: var(--primary-color);
  color: var(--text-color);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: left var(--transition-speed) ease;
}

.sidebar-closed .sidebar-toggle {
  left: var(--sidebar-collapsed-width);
}

.sidebar-menu {
  list-style-type: none;
  padding: 1rem 0;
}

.sidebar-menu li a {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  color: var(--text-color);
  text-decoration: none;
  transition: all var(--transition-speed);
}

.sidebar-menu li a:hover,
.sidebar-menu li.active a {
  background-color: rgba(255, 255, 255, 0.1);
}

.sidebar-menu li a svg {
  font-size: 1.2rem;
  margin-right: 1rem;
}

.sidebar-closed .sidebar-menu li a span {
  display: none;
}

.sidebar-footer {
  margin-top: auto;
  padding: 1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.logout-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0.75rem;
  background-color: var(--primary-color);
  color: var(--text-color);
  border: none;
  border-radius: var(--border-radius);
  cursor: pointer;
  transition: background-color var(--transition-speed);
}

.logout-btn:hover {
  background-color: var(--primary-hover);
}

.logout-btn svg {
  margin-right: 0.5rem;
}

.content {
  flex-grow: 1;
  margin-left: var(--sidebar-width);
  padding: 2rem;
  transition: margin-left var(--transition-speed);
}

.sidebar-closed .content {
  margin-left: var(--sidebar-collapsed-width);
}

.movie-page {
  max-width: 1200px;
  margin: 0 auto;
}

.page-title {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: var(--primary-color);
}

.card {
  background-color: var(--surface-color);
  border-radius: var(--border-radius);
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.card-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: var(--primary-color);
}

.form-group {
  margin-bottom: 1rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  color: var(--text-color-secondary);
}

.form-group input,
.form-group select {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid var(--surface-color);
  border-radius: var(--border-radius);
  background-color: var(--background-color);
  color: var(--text-color);
  font-size: 1rem;
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: var(--primary-color);
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem 1rem;
  border: none;
  border-radius: var(--border-radius);
  cursor: pointer;
  transition: background-color var(--transition-speed);
  font-size: 1rem;
  font-weight: 500;
}

.btn svg {
  margin-right: 0.5rem;
}

.btn-primary {
  background-color: var(--primary-color);
  color: var(--text-color);
}

.btn-primary:hover {
  background-color: var(--primary-hover);
}

.btn-success {
  background-color: var(--success-color);
  color: var(--text-color);
}

.btn-success:hover {
  background-color: #0d9488;
}

.btn-warning {
  background-color: var(--warning-color);
  color: var(--text-color);
}

.btn-warning:hover {
  background-color: #d97706;
}

.btn-danger {
  background-color: var(--error-color);
  color: var(--text-color);
}

.btn-danger:hover {
  background-color: #dc2626;
}

.btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.dashboard-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin-bottom: 1.5rem;
}



.dashboard-card h3 {
  font-size: 0.9rem;
  color: var(--text-color-secondary);
  margin-bottom: 0.5rem;
}

.dashboard-card p {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--primary-color);
}

.progress-bar {
  width: 100%;
  height: 8px;
  background-color: var(--background-color);
  border-radius: var(--border-radius);
  overflow: hidden;
  margin-bottom: 1rem;
}

.progress {
  height: 100%;
  background-color: var(--primary-color);
  transition: width var(--transition-speed) ease-in-out;
}

.log-container {
  margin-top: 1.5rem;
}

.log-list {
  max-height: 200px;
  overflow-y: auto;
  background-color: var(--background-color);
  border-radius: var(--border-radius);
  padding: 1rem;
  font-size: 0.9rem;
}

.log-list li {
  margin-bottom: 0.5rem;
}

.button-group {
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;
}

.error {
  color: var(--error-color);
  background-color: rgba(239, 68, 68, 0.1);
  padding: 0.75rem;
  border-radius: var(--border-radius);
  margin-bottom: 1rem;
}

.success-message {
  color: var(--success-color);
  background-color: rgba(16, 185, 129, 0.1);
  padding: 0.75rem;
  border-radius: var(--border-radius);
  margin-bottom: 1rem;
}
@media (max-width: 768px) {
  .sidebar {
    transform: translateX(-100%);
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    z-index: 1000;
    width: 250px;
  }

  .sidebar-open .sidebar {
    transform: translateX(0);
  }

  .content {
    margin-left: 0;
    padding: 1rem;
  }

  .sidebar-closed .content {
    margin-left: 0;
  }

  .sidebar-toggle {
    display: flex;
    position: fixed;
    top: 1rem;
    left: 1rem;
    z-index: 1001;
  }

.sidebar-header {
    padding: 1rem;
    display: -webkit-box;
    align-items: start;
    justify-content: center;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

  .user-info {
    margin-left: 0;
    margin-top: 1rem;
    text-align: center;
  }

  .dashboard-grid {
    grid-template-columns: 1fr;
  }

  .button-group {
    flex-direction: column;
  }

  .button-group .btn {
    width: 100%;
  }

  .card {
    padding: 1rem;
  }

  .page-title {
    font-size: 1.5rem;
  }

  .card-title {
    font-size: 1.25rem;
  }

  .form-group input,
  .form-group select,
  .btn {
    font-size: 0.875rem;
  }

  .log-list {
    max-height: 150px;
  }
}
.login-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: var(--background-color);
}

.login-container {
  width: 100%;
  max-width: 400px;
  padding: 2rem;
}

.login-form {
  width: 100%;
}

.login-form .form-group {
  margin-bottom: 1.5rem;
}

.login-form label {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}

.login-form label svg {
  margin-right: 0.5rem;
}

.login-form input {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid var(--surface-color);
  border-radius: var(--border-radius);
  background-color: var(--background-color);
  color: var(--text-color);
  font-size: 1rem;
}

.login-form input:focus {
  outline: none;
  border-color: var(--primary-color);
}

.login-form .btn {
  width: 100%;
  margin-top: 1rem;
}
.icon-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.home-page {
  max-width: 1200px;
  margin: 0 auto;
}

.status-online {
  color: var(--success-color);
}

.status-offline {
  color: var(--error-color);
}

.tutorials-section {
  margin-top: 2rem;
}

.tutorial-card {
  background-color: var(--surface-color);
  border-radius: var(--border-radius);
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.tutorial-card h3 {
  color: var(--primary-color);
  margin-bottom: 1rem;
}

.tutorial-card ol {
  padding-left: 1.5rem;
}

.tutorial-card li {
  margin-bottom: 0.5rem;
}
.dashboard-card p {
  margin-bottom: 0.5rem;
}

.dashboard-card p:last-child {
  margin-bottom: 0;
}
/* Estilos existentes ... */

.home-page {
  padding: 20px;
}

.dashboard-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.dashboard-card {
    background-color: var(--surface-color);
    border-radius: 15px;
    padding: 1.5rem;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    display: flex;
    align-items: flex-start;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    height: 125px;
}

.dashboard-card h3 {
  margin-top: 0;
  margin-bottom: 15px;
  font-size: 18px;
}

.status-online {
  color: #4CAF50;
}

.status-offline {
  color: #F44336;
}

.tutorials-section {
  background-color: transparent;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.tutorial-card {
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}

.tutorial-card:last-child {
  border-bottom: none;
}

.tutorial-card h3 {
  margin-top: 0;
  font-size: 16px;
}

.icon-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
/* Estilos atualizados para o HomePage */

.home-page {
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.page-title {
  font-size: 2.5rem;
  color: var(--primary-color);
  margin-bottom: 2rem;
  text-align: center;
  font-weight: 700;
}

.dashboard-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
  margin-bottom: 3rem;
}

.dashboard-card {
  background-color: var(--surface-color);
  border-radius: 15px;
  padding: 1.5rem;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  align-items: flex-start;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.dashboard-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);
}

.card-icon {
  font-size: 2.5rem;
  color: var(--primary-color);
  margin-right: 1.5rem;
  background-color: rgba(109, 40, 217, 0.1); /* Cor primária com opacidade */
  padding: 1rem;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-content {
  flex: 1 1;
}

.dashboard-card h3 {
  font-size: 1.2rem;
  color: var(--text-color);
  margin-bottom: 0.75rem;
  font-weight: 600;
}

.status {
    display: inline-block;
    align-items: center;
    font-size: 1rem;
    font-weight: 500;
}

.status svg {
  margin-right: 0.5rem;
}

.status-online {
  color: var(--success-color);
}

.status-offline {
  color: var(--error-color);
}

.response-time {
    font-size: 0.9rem;
    color: var(--text-color-secondary);
    margin-top: 0.5rem;
    display: block !important;
    display: inline-block !important;
    font-size: 13px !important;
    margin-left: 9px;
}

.subscription-type, .subscription-days {
    display: flex;
    align-items: center;
    font-size: 1rem;
    margin-bottom: -3px !important;
    margin-bottom: 0.5rem;
    margin-top: -6px;
    font-size: 17px !important;
}

.subscription-type svg, .subscription-days svg {
  margin-right: 0.5rem;
}

.section-title {
  font-size: 2rem;
  color: var(--primary-color);
  margin-bottom: 2rem;
  text-align: center;
  font-weight: 700;
}

.tutorials-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
}

.tutorial-card {
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #000;
}

.tutorial-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);
}

.tutorial-card h3 {
  font-size: 1.2rem;
  color: var(--primary-color);
  margin-bottom: 1rem;
  font-weight: 600;
}

.tutorial-card p {
  font-size: 1rem;
  margin-bottom: 1.5rem;
  color: var(--text-color);
}

.tutorial-card .btn {
  font-size: 0.9rem;
  padding: 0.75rem 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.tutorial-card .btn:hover {
  background-color: var(--primary-hover);
}

.tutorial-card .btn svg {
  margin-left: 0.5rem;
}

.loading-card, .error-card {
  text-align: center;
  padding: 3rem;
  background-color: var(--surface-color);
  border-radius: 15px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.loading-card .icon-spin, .error-card .error-icon {
  font-size: 3rem;
  margin-bottom: 1.5rem;
  color: var(--primary-color);
}

.error-card {
  color: var(--error-color);
}

@media (max-width: 768px) {
  .home-page {
    padding: 1rem;
  }

  .page-title {
    font-size: 2rem;
  }

  .dashboard-grid, .tutorials-grid {
    grid-template-columns: 1fr;
  }

.dashboard-card {
    background-color: var(--surface-color);
    border-radius: 15px;
    padding: 1.5rem;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    display: flex;
    align-items: flex-start;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    height: 125px;
}

  .card-icon {
    margin-right: 0;
    margin-bottom: 1rem;
  }
}
/* Adicione estes estilos ao seu arquivo CSS existente */

.online-status {
  display: flex;
  align-items: center;
  color: #4CAF50; /* Cor verde para o status online */
  font-size: 0.9rem;
}

.online-icon {
    font-size: 0.6rem;
    margin-right: 0.5rem;
    color: #10b981;
}

.user-info h3 {
  margin-bottom: 0.25rem;
}

/* Ajuste o espaçamento do sidebar-header se necessário */
.sidebar-header {
  padding: 1rem;
}

/* Você pode querer ajustar o tamanho da fonte ou espaçamento do menu */
.sidebar-menu li a {
  padding: 0.75rem 1rem;
}

/* Certifique-se de que o ícone e o texto estão alinhados corretamente */
.sidebar-menu li a svg {
  margin-right: 0.75rem;
}
.db-config-section {
  background-color: var(--surface-color);
  border-radius: 15px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.db-config-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.db-config-form input {
  padding: 0.75rem;
  border: 1px solid var(--text-color-secondary);
  border-radius: 8px;
  font-size: 1rem;
  background-color: var(--background-color);
  color: var(--text-color);
}

.db-config-form input:focus {
  outline: none;
  border-color: var(--primary-color);
}

.db-config-form .btn {
  align-self: flex-start;
  padding: 0.75rem 1rem;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  font-size: 1rem;
  display: flex;
  align-items: center;
}

.db-config-form .btn:hover {
  background-color: var(--primary-hover);
}

.db-config-form .btn svg {
  margin-right: 0.5rem;
}

@media (max-width: 768px) {
  .db-config-form .btn {
    align-self: stretch;
  }
}
/* Estilos para MoviePage */
.movie-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
}

.movie-page__title {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: var(--primary-color);
}

.movie-page__card {
  background-color: var(--surface-color);
  border-radius: var(--border-radius);
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.movie-page__card-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: var(--primary-color);
}

.movie-page__form-group {
  margin-bottom: 1rem;
}

.movie-page__form-group label {
  display: block;
  margin-bottom: 0.5rem;
  color: var(--text-color-secondary);
}

.movie-page__form-group input,
.movie-page__form-group select {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid var(--surface-color);
  border-radius: var(--border-radius);
  background-color: var(--background-color);
  color: var(--text-color);
  font-size: 1rem;
}

.movie-page__form-group input:focus,
.movie-page__form-group select:focus {
  outline: none;
  border-color: var(--primary-color);
}

.movie-page__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem 1rem;
  border: none;
  border-radius: var(--border-radius);
  cursor: pointer;
  transition: background-color var(--transition-speed);
  font-size: 1rem;
  font-weight: 500;
}

.movie-page__btn svg {
  margin-right: 0.5rem;
}

.movie-page__btn--primary {
  background-color: var(--primary-color);
  color: var(--text-color);
}

.movie-page__btn--primary:hover {
  background-color: var(--primary-hover);
}

.movie-page__btn--success {
  background-color: var(--success-color);
  color: var(--text-color);
}

.movie-page__btn--success:hover {
  background-color: #0d9488;
}

.movie-page__btn--warning {
  background-color: var(--warning-color);
  color: var(--text-color);
}

.movie-page__btn--warning:hover {
  background-color: #d97706;
}

.movie-page__btn--danger {
  background-color: var(--error-color);
  color: var(--text-color);
}

.movie-page__btn--danger:hover {
  background-color: #dc2626;
}

.movie-page__btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.movie-page__stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.movie-page__stats-card {
  background-color: var(--background-color);
  border-radius: var(--border-radius);
  padding: 1rem;
  text-align: center;
}

.movie-page__stats-card h3 {
  font-size: 0.9rem;
  color: var(--text-color-secondary);
  margin-bottom: 0.5rem;
}

.movie-page__stats-card p {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--primary-color);
}

.movie-page__progress-bar {
  width: 100%;
  height: 8px;
  background-color: var(--background-color);
  border-radius: var(--border-radius);
  overflow: hidden;
  margin-bottom: 1rem;
}

.movie-page__progress {
  height: 100%;
  background-color: var(--primary-color);
  transition: width var(--transition-speed) ease-in-out;
}

.movie-page__log-container {
  margin-top: 1.5rem;
}

.movie-page__log-list {
    max-height: 200px;
    overflow-y: auto;
    background-color: var(--background-color);
    border-radius: var(--border-radius);
    padding: 1rem;
    font-size: 0.9rem;
    padding-left: 28px;
    padding-top: 11px;
    font-weight: 100;
}

.movie-page__log-list li {
  margin-bottom: 0.5rem;
}

.movie-page__button-group {
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;
}

.movie-page__error {
  color: var(--error-color);
  background-color: rgba(239, 68, 68, 0.1);
  padding: 0.75rem;
  border-radius: var(--border-radius);
  margin-bottom: 1rem;
}

.movie-page__success-message {
  color: var(--success-color);
  background-color: rgba(16, 185, 129, 0.1);
  padding: 0.75rem;
  border-radius: var(--border-radius);
  margin-bottom: 1rem;
}

.movie-page__success-text {
  font-weight: bold;
}

@media (max-width: 768px) {
  .movie-page {
    padding: 1rem;
  }

  .movie-page__title {
    font-size: 1.5rem;
  }

  .movie-page__card-title {
    font-size: 1.25rem;
  }

  .movie-page__form-group input,
  .movie-page__form-group select,
  .movie-page__btn {
    font-size: 0.875rem;
  }

  .movie-page__log-list {
    max-height: 150px;
  }

  .movie-page__button-group {
    flex-direction: column;
  }

  .movie-page__button-group .movie-page__btn {
    width: 100%;
  }
}
/* Estilos para SeriesPage */
.series-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
}

.series-page__title {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: var(--primary-color);
}

.series-page__card {
  background-color: var(--surface-color);
  border-radius: var(--border-radius);
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.series-page__card-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: var(--primary-color);
}

.series-page__form {
  margin-bottom: 1rem;
}

.series-page__form-group {
  margin-bottom: 1rem;
}

.series-page__form-group label {
  display: block;
  margin-bottom: 0.5rem;
  color: var(--text-color-secondary);
}

.series-page__form-group input,
.series-page__form-group select {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid var(--surface-color);
  border-radius: var(--border-radius);
  background-color: var(--background-color);
  color: var(--text-color);
  font-size: 1rem;
}

.series-page__form-group input:focus,
.series-page__form-group select:focus {
  outline: none;
  border-color: var(--primary-color);
}

.series-page__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem 1rem;
  border: none;
  border-radius: var(--border-radius);
  cursor: pointer;
  transition: background-color var(--transition-speed);
  font-size: 1rem;
  font-weight: 500;
}

.series-page__btn svg {
  margin-right: 0.5rem;
}

.series-page__btn--primary {
  background-color: var(--primary-color);
  color: var(--text-color);
}

.series-page__btn--primary:hover {
  background-color: var(--primary-hover);
}

.series-page__btn--success {
  background-color: var(--success-color);
  color: var(--text-color);
}

.series-page__btn--success:hover {
  background-color: #0d9488;
}

.series-page__btn--warning {
  background-color: var(--warning-color);
  color: var(--text-color);
}

.series-page__btn--warning:hover {
  background-color: #d97706;
}

.series-page__btn--danger {
  background-color: var(--error-color);
  color: var(--text-color);
}

.series-page__btn--danger:hover {
  background-color: #dc2626;
}

.series-page__btn--secondary {
  background-color: var(--text-color-secondary);
  color: var(--text-color);
}

.series-page__btn--secondary:hover {
  background-color: #6b7280;
}

.series-page__btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.series-page__stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.series-page__stats-card {
  background-color: var(--background-color);
  border-radius: var(--border-radius);
  padding: 1rem;
  text-align: center;
}

.series-page__stats-card h3 {
  font-size: 0.9rem;
  color: var(--text-color-secondary);
  margin-bottom: 0.5rem;
}

.series-page__stats-card p {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--primary-color);
}

.series-page__progress-bar {
  width: 100%;
  height: 8px;
  background-color: var(--background-color);
  border-radius: var(--border-radius);
  overflow: hidden;
  margin-bottom: 1rem;
}

.series-page__progress {
  height: 100%;
  background-color: var(--primary-color);
  transition: width var(--transition-speed) ease-in-out;
}

.series-page__log-container {
  margin-top: 1.5rem;
}

.series-page__log-list {
  max-height: 200px;
  overflow-y: auto;
  background-color: var(--background-color);
  border-radius: var(--border-radius);
  padding: 1rem;
  font-size: 0.9rem;
}

.series-page__log-list li {
  margin-bottom: 0.5rem;
}

.series-page__button-group {
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;
}

.series-page__error {
  color: var(--error-color);
  background-color: rgba(239, 68, 68, 0.1);
  padding: 0.75rem;
  border-radius: var(--border-radius);
  margin-bottom: 1rem;
}

.series-page__success-message {
  color: var(--success-color);
  background-color: rgba(16, 185, 129, 0.1);
  padding: 0.75rem;
  border-radius: var(--border-radius);
  margin-bottom: 1rem;
}

.series-page__success-text {
  font-weight: bold;
}

.series-page__subtitle {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: var(--primary-color);
}

.series-page__category-list {
  list-style-type: none;
  padding-left: 0;
  margin-bottom: 1.5rem;
}

.series-page__category-list li {
  margin-bottom: 0.5rem;
  padding: 0.5rem;
  background-color: var(--background-color);
  border-radius: var(--border-radius);
}

@media (max-width: 768px) {
  .series-page {
    padding: 1rem;
  }

  .series-page__title {
    font-size: 1.5rem;
  }

  .series-page__card-title {
    font-size: 1.25rem;
  }

  .series-page__form-group input,
  .series-page__form-group select,
  .series-page__btn {
    font-size: 0.875rem;
  }

  .series-page__log-list {
    max-height: 150px;
  }

  .series-page__button-group {
    flex-direction: column;
  }

  .series-page__button-group .series-page__btn {
    width: 100%;
  }

  .series-page__stats-grid {
    grid-template-columns: 1fr;
  }
}
.tutorial-card {
  background-color: var(--surface-color);
  border-radius: var(--border-radius);
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.tutorial-card h3 {
  color: var(--primary-color);
  margin-bottom: 1rem;
}

.tutorial-card ol, .tutorial-card ul {
  padding-left: 1.5rem;
  margin-bottom: 1rem;
}

.tutorial-card li {
  margin-bottom: 0.5rem;
}

.copyable-text {
  background-color: var(--background-color);
  padding: 0.5rem;
  border-radius: var(--border-radius);
  margin: 0.5rem 0;
  position: relative;
  font-family: monospace;
  white-space: pre-wrap;
  word-break: break-all;
}

.copy-button {
  position: absolute;
  right: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 4px;
  padding: 0.25rem 0.5rem;
  cursor: pointer;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
}

.copy-button:hover {
  background-color: var(--primary-hover);
}

.copy-button svg {
  margin-right: 0.25rem;
}
.movie-page__category-controls {
    display: inline-block;
    justify-content: space-between;
    margin-bottom: 1rem;
    margin-left: 60px;
}
.movie-page__category-controls .movie-page__btn {
    padding: 0.5rem 2rem;
    font-size: 0.9rem;
    margin-left: 6px;
}

.movie-page__categories-list {
    max-height: 100%;
    overflow-y: auto;
    border: 1px solid var(--surface-color);
    border-radius: var(--border-radius);
    padding: 0.5rem;
    margin-bottom: 1rem;
    display: inline-block;
}

.movie-page__category-item {
    display: inline-block;
    align-items: center;
    margin-left: 49px;
    padding: 0.5rem;
    width: 300px;
    margin-bottom: 12px;
    background-color: var(--background-color);
    border-radius: var(--border-radius);
}

.movie-page__category-item input[type="checkbox"] {
  margin-right: 0.5rem;
}

.movie-page__category-item input[type="text"] {
    flex-grow: 1;
    margin-right: 0.5rem;
    background: #101521;
    padding: 0.50rem;
    color: #fff;
    border: none;
}

.movie-page__category-item span {
  font-size: 0.8rem;
  color: var(--text-color-secondary);
}
.notification {
  padding: 10px;
  margin-bottom: 15px;
  border-radius: var(--border-radius);
  text-align: center;
  font-weight: bold;
}

.notification.success {
  background-color: rgba(16, 185, 129, 0.1);
  color: var(--success-color);
  border: 1px solid var(--success-color);
}

.notification.error {
  background-color: rgba(239, 68, 68, 0.1);
  color: var(--error-color);
  border: 1px solid var(--error-color);
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;IACI,wBAAwB;IACxB,wBAAwB;EAC1B,0BAA0B;EAC1B,2BAA2B;EAC3B,wBAAwB;EACxB,qBAAqB;EACrB,+BAA+B;EAC/B,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;EACtB,+BAA+B;EAC/B,qBAAqB;EACrB,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,yCAAyC;EACzC,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,8CAA8C;EAC9C,eAAe;EACf,MAAM;EACN,SAAS;EACT,OAAO;EACP,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;IACI,iBAAiB;IACjB,kCAAkC;IAClC,cAAc;AAClB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,0BAA0B;EAC1B,aAAa;EACb,sCAAsC;EACtC,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,wBAAwB;EACxB,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,sCAAsC;EACtC,wBAAwB;EACxB,YAAY;EACZ,mCAAmC;EACnC,eAAe;EACf,oDAAoD;AACtD;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,iCAAiC;EACjC,aAAa;EACb,+CAA+C;AACjD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,eAAe;EACf,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,sCAAsC;EACtC,mCAAmC;EACnC,yCAAyC;EACzC,wBAAwB;EACxB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,YAAY;EACZ,mCAAmC;EACnC,eAAe;EACf,oDAAoD;EACpD,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,qBAAqB;AACvB;;;;AAIA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yCAAyC;EACzC,mCAAmC;EACnC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,sCAAsC;EACtC,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;EACzC,mCAAmC;EACnC,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;AACrB;AACA;EACE;IACE,4BAA4B;IAC5B,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,aAAa;IACb,YAAY;EACd;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT,UAAU;IACV,aAAa;EACf;;AAEF;IACI,aAAa;IACb,oBAAoB;IACpB,kBAAkB;IAClB,uBAAuB;IACvB,iDAAiD;AACrD;;EAEE;IACE,cAAc;IACd,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;IAGE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;AACF;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sCAAsC;EACtC,mCAAmC;EACnC,yCAAyC;EACzC,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,eAAe;EACf,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;AACA,2BAA2B;;AAE3B;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;IACI,sCAAsC;IACtC,mBAAmB;IACnB,eAAe;IACf,qDAAqD;IACrD,aAAa;IACb,uBAAuB;IACvB,wCAAwC;IACxC,aAAa;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;AACA,wCAAwC;;AAExC;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;EACf,qDAAqD;EACrD,aAAa;EACb,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,oBAAoB;EACpB,yCAAyC,EAAE,+BAA+B;EAC1E,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,kCAAkC;IAClC,kBAAkB;IAClB,yBAAyB;IACzB,gCAAgC;IAChC,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,8BAA8B;IAC9B,qBAAqB;IACrB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;AAEF;IACI,sCAAsC;IACtC,mBAAmB;IACnB,eAAe;IACf,qDAAqD;IACrD,aAAa;IACb,uBAAuB;IACvB,wCAAwC;IACxC,aAAa;AACjB;;EAEE;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;AACA,wDAAwD;;AAExD;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc,EAAE,mCAAmC;EACnD,iBAAiB;AACnB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,cAAc;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,yDAAyD;AACzD;EACE,aAAa;AACf;;AAEA,uEAAuE;AACvE;EACE,qBAAqB;AACvB;;AAEA,wEAAwE;AACxE;EACE,qBAAqB;AACvB;AACA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,6CAA6C;EAC7C,kBAAkB;EAClB,eAAe;EACf,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,sCAAsC;EACtC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;AACA,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,eAAe;EACf,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,sCAAsC;EACtC,mCAAmC;EACnC,yCAAyC;EACzC,wBAAwB;EACxB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,YAAY;EACZ,mCAAmC;EACnC,eAAe;EACf,oDAAoD;EACpD,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;EACzC,mCAAmC;EACnC,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yCAAyC;EACzC,mCAAmC;EACnC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,sCAAsC;EACtC,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,yCAAyC;IACzC,mCAAmC;IACnC,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;IAGE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;AACA,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,eAAe;EACf,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,sCAAsC;EACtC,mCAAmC;EACnC,yCAAyC;EACzC,wBAAwB;EACxB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,YAAY;EACZ,mCAAmC;EACnC,eAAe;EACf,oDAAoD;EACpD,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;EAC7C,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;EACzC,mCAAmC;EACnC,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yCAAyC;EACzC,mCAAmC;EACnC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,sCAAsC;EACtC,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;EACzC,mCAAmC;EACnC,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,yCAAyC;EACzC,mCAAmC;AACrC;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;IAGE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,eAAe;EACf,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,sCAAsC;EACtC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;AACvB;AACA;IACI,qBAAqB;IACrB,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,sCAAsC;IACtC,mCAAmC;IACnC,eAAe;IACf,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,yCAAyC;IACzC,mCAAmC;AACvC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;EACzB,oCAAoC;AACtC","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');\n\n:root {\n    --primary-color: #4caf50;\n    --primary-hover: #4caf50;\n  --secondary-color: #10b981;\n  --background-color: #111827;\n  --surface-color: #1f2937;\n  --text-color: #f3f4f6;\n  --text-color-secondary: #9ca3af;\n  --error-color: #ef4444;\n  --success-color: #10b981;\n  --warning-color: #f59e0b;\n  --sidebar-width: 225px;\n  --sidebar-collapsed-width: 70px;\n  --header-height: 60px;\n  --border-radius: 8px;\n  --transition-speed: 0.3s;\n}\n\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  font-family: 'Poppins', sans-serif;\n  background-color: var(--background-color);\n  color: var(--text-color);\n  line-height: 1.6;\n}\n\n.dashboard {\n  display: flex;\n  min-height: 100vh;\n}\n\n.sidebar {\n  width: var(--sidebar-width);\n  background-color: var(--surface-color);\n  transition: width var(--transition-speed) ease;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1000;\n  overflow-x: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.sidebar-closed .sidebar {\n  width: var(--sidebar-collapsed-width);\n}\n\n.sidebar-header {\n  padding: 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.avatar {\n  width: 40px;\n  height: 40px;\n  background-color: var(--primary-color);\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 1.2rem;\n}\n\n.user-info {\n  margin-left: 1rem;\n}\n\n.user-info h3 {\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n\n.user-info p {\n    font-size: 0.8rem;\n    color: var(--text-color-secondary);\n    color: #4CAF50;\n}\n\n.sidebar-toggle {\n  position: fixed;\n  top: 1rem;\n  left: var(--sidebar-width);\n  z-index: 1001;\n  background-color: var(--primary-color);\n  color: var(--text-color);\n  border: none;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  transition: left var(--transition-speed) ease;\n}\n\n.sidebar-closed .sidebar-toggle {\n  left: var(--sidebar-collapsed-width);\n}\n\n.sidebar-menu {\n  list-style-type: none;\n  padding: 1rem 0;\n}\n\n.sidebar-menu li a {\n  display: flex;\n  align-items: center;\n  padding: 0.75rem 1rem;\n  color: var(--text-color);\n  text-decoration: none;\n  transition: all var(--transition-speed);\n}\n\n.sidebar-menu li a:hover,\n.sidebar-menu li.active a {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.sidebar-menu li a svg {\n  font-size: 1.2rem;\n  margin-right: 1rem;\n}\n\n.sidebar-closed .sidebar-menu li a span {\n  display: none;\n}\n\n.sidebar-footer {\n  margin-top: auto;\n  padding: 1rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.logout-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 0.75rem;\n  background-color: var(--primary-color);\n  color: var(--text-color);\n  border: none;\n  border-radius: var(--border-radius);\n  cursor: pointer;\n  transition: background-color var(--transition-speed);\n}\n\n.logout-btn:hover {\n  background-color: var(--primary-hover);\n}\n\n.logout-btn svg {\n  margin-right: 0.5rem;\n}\n\n.content {\n  flex-grow: 1;\n  margin-left: var(--sidebar-width);\n  padding: 2rem;\n  transition: margin-left var(--transition-speed);\n}\n\n.sidebar-closed .content {\n  margin-left: var(--sidebar-collapsed-width);\n}\n\n.movie-page {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.page-title {\n  font-size: 2rem;\n  font-weight: 700;\n  margin-bottom: 1.5rem;\n  color: var(--primary-color);\n}\n\n.card {\n  background-color: var(--surface-color);\n  border-radius: var(--border-radius);\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.card-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n  color: var(--primary-color);\n}\n\n.form-group {\n  margin-bottom: 1rem;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  color: var(--text-color-secondary);\n}\n\n.form-group input,\n.form-group select {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid var(--surface-color);\n  border-radius: var(--border-radius);\n  background-color: var(--background-color);\n  color: var(--text-color);\n  font-size: 1rem;\n}\n\n.form-group input:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: var(--primary-color);\n}\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.75rem 1rem;\n  border: none;\n  border-radius: var(--border-radius);\n  cursor: pointer;\n  transition: background-color var(--transition-speed);\n  font-size: 1rem;\n  font-weight: 500;\n}\n\n.btn svg {\n  margin-right: 0.5rem;\n}\n\n.btn-primary {\n  background-color: var(--primary-color);\n  color: var(--text-color);\n}\n\n.btn-primary:hover {\n  background-color: var(--primary-hover);\n}\n\n.btn-success {\n  background-color: var(--success-color);\n  color: var(--text-color);\n}\n\n.btn-success:hover {\n  background-color: #0d9488;\n}\n\n.btn-warning {\n  background-color: var(--warning-color);\n  color: var(--text-color);\n}\n\n.btn-warning:hover {\n  background-color: #d97706;\n}\n\n.btn-danger {\n  background-color: var(--error-color);\n  color: var(--text-color);\n}\n\n.btn-danger:hover {\n  background-color: #dc2626;\n}\n\n.btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.dashboard-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n\n\n.dashboard-card h3 {\n  font-size: 0.9rem;\n  color: var(--text-color-secondary);\n  margin-bottom: 0.5rem;\n}\n\n.dashboard-card p {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--primary-color);\n}\n\n.progress-bar {\n  width: 100%;\n  height: 8px;\n  background-color: var(--background-color);\n  border-radius: var(--border-radius);\n  overflow: hidden;\n  margin-bottom: 1rem;\n}\n\n.progress {\n  height: 100%;\n  background-color: var(--primary-color);\n  transition: width var(--transition-speed) ease-in-out;\n}\n\n.log-container {\n  margin-top: 1.5rem;\n}\n\n.log-list {\n  max-height: 200px;\n  overflow-y: auto;\n  background-color: var(--background-color);\n  border-radius: var(--border-radius);\n  padding: 1rem;\n  font-size: 0.9rem;\n}\n\n.log-list li {\n  margin-bottom: 0.5rem;\n}\n\n.button-group {\n  display: flex;\n  gap: 1rem;\n  margin-top: 1.5rem;\n}\n\n.error {\n  color: var(--error-color);\n  background-color: rgba(239, 68, 68, 0.1);\n  padding: 0.75rem;\n  border-radius: var(--border-radius);\n  margin-bottom: 1rem;\n}\n\n.success-message {\n  color: var(--success-color);\n  background-color: rgba(16, 185, 129, 0.1);\n  padding: 0.75rem;\n  border-radius: var(--border-radius);\n  margin-bottom: 1rem;\n}\n@media (max-width: 768px) {\n  .sidebar {\n    transform: translateX(-100%);\n    position: fixed;\n    top: 0;\n    left: 0;\n    height: 100vh;\n    z-index: 1000;\n    width: 250px;\n  }\n\n  .sidebar-open .sidebar {\n    transform: translateX(0);\n  }\n\n  .content {\n    margin-left: 0;\n    padding: 1rem;\n  }\n\n  .sidebar-closed .content {\n    margin-left: 0;\n  }\n\n  .sidebar-toggle {\n    display: flex;\n    position: fixed;\n    top: 1rem;\n    left: 1rem;\n    z-index: 1001;\n  }\n\n.sidebar-header {\n    padding: 1rem;\n    display: -webkit-box;\n    align-items: start;\n    justify-content: center;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n  .user-info {\n    margin-left: 0;\n    margin-top: 1rem;\n    text-align: center;\n  }\n\n  .dashboard-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .button-group {\n    flex-direction: column;\n  }\n\n  .button-group .btn {\n    width: 100%;\n  }\n\n  .card {\n    padding: 1rem;\n  }\n\n  .page-title {\n    font-size: 1.5rem;\n  }\n\n  .card-title {\n    font-size: 1.25rem;\n  }\n\n  .form-group input,\n  .form-group select,\n  .btn {\n    font-size: 0.875rem;\n  }\n\n  .log-list {\n    max-height: 150px;\n  }\n}\n.login-page {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background-color: var(--background-color);\n}\n\n.login-container {\n  width: 100%;\n  max-width: 400px;\n  padding: 2rem;\n}\n\n.login-form {\n  width: 100%;\n}\n\n.login-form .form-group {\n  margin-bottom: 1.5rem;\n}\n\n.login-form label {\n  display: flex;\n  align-items: center;\n  margin-bottom: 0.5rem;\n}\n\n.login-form label svg {\n  margin-right: 0.5rem;\n}\n\n.login-form input {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid var(--surface-color);\n  border-radius: var(--border-radius);\n  background-color: var(--background-color);\n  color: var(--text-color);\n  font-size: 1rem;\n}\n\n.login-form input:focus {\n  outline: none;\n  border-color: var(--primary-color);\n}\n\n.login-form .btn {\n  width: 100%;\n  margin-top: 1rem;\n}\n.icon-spin {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n.home-page {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.status-online {\n  color: var(--success-color);\n}\n\n.status-offline {\n  color: var(--error-color);\n}\n\n.tutorials-section {\n  margin-top: 2rem;\n}\n\n.tutorial-card {\n  background-color: var(--surface-color);\n  border-radius: var(--border-radius);\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.tutorial-card h3 {\n  color: var(--primary-color);\n  margin-bottom: 1rem;\n}\n\n.tutorial-card ol {\n  padding-left: 1.5rem;\n}\n\n.tutorial-card li {\n  margin-bottom: 0.5rem;\n}\n.dashboard-card p {\n  margin-bottom: 0.5rem;\n}\n\n.dashboard-card p:last-child {\n  margin-bottom: 0;\n}\n/* Estilos existentes ... */\n\n.home-page {\n  padding: 20px;\n}\n\n.dashboard-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n.dashboard-card {\n    background-color: var(--surface-color);\n    border-radius: 15px;\n    padding: 1.5rem;\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n    display: flex;\n    align-items: flex-start;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    height: 125px;\n}\n\n.dashboard-card h3 {\n  margin-top: 0;\n  margin-bottom: 15px;\n  font-size: 18px;\n}\n\n.status-online {\n  color: #4CAF50;\n}\n\n.status-offline {\n  color: #F44336;\n}\n\n.tutorials-section {\n  background-color: transparent;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.tutorial-card {\n  margin-bottom: 20px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid #eee;\n}\n\n.tutorial-card:last-child {\n  border-bottom: none;\n}\n\n.tutorial-card h3 {\n  margin-top: 0;\n  font-size: 16px;\n}\n\n.icon-spin {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n/* Estilos atualizados para o HomePage */\n\n.home-page {\n  padding: 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.page-title {\n  font-size: 2.5rem;\n  color: var(--primary-color);\n  margin-bottom: 2rem;\n  text-align: center;\n  font-weight: 700;\n}\n\n.dashboard-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 3rem;\n}\n\n.dashboard-card {\n  background-color: var(--surface-color);\n  border-radius: 15px;\n  padding: 1.5rem;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  display: flex;\n  align-items: flex-start;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.dashboard-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);\n}\n\n.card-icon {\n  font-size: 2.5rem;\n  color: var(--primary-color);\n  margin-right: 1.5rem;\n  background-color: rgba(109, 40, 217, 0.1); /* Cor primária com opacidade */\n  padding: 1rem;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.card-content {\n  flex: 1;\n}\n\n.dashboard-card h3 {\n  font-size: 1.2rem;\n  color: var(--text-color);\n  margin-bottom: 0.75rem;\n  font-weight: 600;\n}\n\n.status {\n    display: inline-block;\n    align-items: center;\n    font-size: 1rem;\n    font-weight: 500;\n}\n\n.status svg {\n  margin-right: 0.5rem;\n}\n\n.status-online {\n  color: var(--success-color);\n}\n\n.status-offline {\n  color: var(--error-color);\n}\n\n.response-time {\n    font-size: 0.9rem;\n    color: var(--text-color-secondary);\n    margin-top: 0.5rem;\n    display: block !important;\n    display: inline-block !important;\n    font-size: 13px !important;\n    margin-left: 9px;\n}\n\n.subscription-type, .subscription-days {\n    display: flex;\n    align-items: center;\n    font-size: 1rem;\n    margin-bottom: -3px !important;\n    margin-bottom: 0.5rem;\n    margin-top: -6px;\n    font-size: 17px !important;\n}\n\n.subscription-type svg, .subscription-days svg {\n  margin-right: 0.5rem;\n}\n\n.section-title {\n  font-size: 2rem;\n  color: var(--primary-color);\n  margin-bottom: 2rem;\n  text-align: center;\n  font-weight: 700;\n}\n\n.tutorials-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 1.5rem;\n}\n\n.tutorial-card {\n    margin-bottom: 20px;\n    padding-bottom: 20px;\n    border-bottom: 1px solid #000;\n}\n\n.tutorial-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);\n}\n\n.tutorial-card h3 {\n  font-size: 1.2rem;\n  color: var(--primary-color);\n  margin-bottom: 1rem;\n  font-weight: 600;\n}\n\n.tutorial-card p {\n  font-size: 1rem;\n  margin-bottom: 1.5rem;\n  color: var(--text-color);\n}\n\n.tutorial-card .btn {\n  font-size: 0.9rem;\n  padding: 0.75rem 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--primary-color);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.tutorial-card .btn:hover {\n  background-color: var(--primary-hover);\n}\n\n.tutorial-card .btn svg {\n  margin-left: 0.5rem;\n}\n\n.loading-card, .error-card {\n  text-align: center;\n  padding: 3rem;\n  background-color: var(--surface-color);\n  border-radius: 15px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.loading-card .icon-spin, .error-card .error-icon {\n  font-size: 3rem;\n  margin-bottom: 1.5rem;\n  color: var(--primary-color);\n}\n\n.error-card {\n  color: var(--error-color);\n}\n\n@media (max-width: 768px) {\n  .home-page {\n    padding: 1rem;\n  }\n\n  .page-title {\n    font-size: 2rem;\n  }\n\n  .dashboard-grid, .tutorials-grid {\n    grid-template-columns: 1fr;\n  }\n\n.dashboard-card {\n    background-color: var(--surface-color);\n    border-radius: 15px;\n    padding: 1.5rem;\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n    display: flex;\n    align-items: flex-start;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    height: 125px;\n}\n\n  .card-icon {\n    margin-right: 0;\n    margin-bottom: 1rem;\n  }\n}\n/* Adicione estes estilos ao seu arquivo CSS existente */\n\n.online-status {\n  display: flex;\n  align-items: center;\n  color: #4CAF50; /* Cor verde para o status online */\n  font-size: 0.9rem;\n}\n\n.online-icon {\n    font-size: 0.6rem;\n    margin-right: 0.5rem;\n    color: #10b981;\n}\n\n.user-info h3 {\n  margin-bottom: 0.25rem;\n}\n\n/* Ajuste o espaçamento do sidebar-header se necessário */\n.sidebar-header {\n  padding: 1rem;\n}\n\n/* Você pode querer ajustar o tamanho da fonte ou espaçamento do menu */\n.sidebar-menu li a {\n  padding: 0.75rem 1rem;\n}\n\n/* Certifique-se de que o ícone e o texto estão alinhados corretamente */\n.sidebar-menu li a svg {\n  margin-right: 0.75rem;\n}\n.db-config-section {\n  background-color: var(--surface-color);\n  border-radius: 15px;\n  padding: 2rem;\n  margin-bottom: 2rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.db-config-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.db-config-form input {\n  padding: 0.75rem;\n  border: 1px solid var(--text-color-secondary);\n  border-radius: 8px;\n  font-size: 1rem;\n  background-color: var(--background-color);\n  color: var(--text-color);\n}\n\n.db-config-form input:focus {\n  outline: none;\n  border-color: var(--primary-color);\n}\n\n.db-config-form .btn {\n  align-self: flex-start;\n  padding: 0.75rem 1rem;\n  background-color: var(--primary-color);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  font-size: 1rem;\n  display: flex;\n  align-items: center;\n}\n\n.db-config-form .btn:hover {\n  background-color: var(--primary-hover);\n}\n\n.db-config-form .btn svg {\n  margin-right: 0.5rem;\n}\n\n@media (max-width: 768px) {\n  .db-config-form .btn {\n    align-self: stretch;\n  }\n}\n/* Estilos para MoviePage */\n.movie-page {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem;\n}\n\n.movie-page__title {\n  font-size: 2rem;\n  font-weight: 700;\n  margin-bottom: 1.5rem;\n  color: var(--primary-color);\n}\n\n.movie-page__card {\n  background-color: var(--surface-color);\n  border-radius: var(--border-radius);\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.movie-page__card-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n  color: var(--primary-color);\n}\n\n.movie-page__form-group {\n  margin-bottom: 1rem;\n}\n\n.movie-page__form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  color: var(--text-color-secondary);\n}\n\n.movie-page__form-group input,\n.movie-page__form-group select {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid var(--surface-color);\n  border-radius: var(--border-radius);\n  background-color: var(--background-color);\n  color: var(--text-color);\n  font-size: 1rem;\n}\n\n.movie-page__form-group input:focus,\n.movie-page__form-group select:focus {\n  outline: none;\n  border-color: var(--primary-color);\n}\n\n.movie-page__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.75rem 1rem;\n  border: none;\n  border-radius: var(--border-radius);\n  cursor: pointer;\n  transition: background-color var(--transition-speed);\n  font-size: 1rem;\n  font-weight: 500;\n}\n\n.movie-page__btn svg {\n  margin-right: 0.5rem;\n}\n\n.movie-page__btn--primary {\n  background-color: var(--primary-color);\n  color: var(--text-color);\n}\n\n.movie-page__btn--primary:hover {\n  background-color: var(--primary-hover);\n}\n\n.movie-page__btn--success {\n  background-color: var(--success-color);\n  color: var(--text-color);\n}\n\n.movie-page__btn--success:hover {\n  background-color: #0d9488;\n}\n\n.movie-page__btn--warning {\n  background-color: var(--warning-color);\n  color: var(--text-color);\n}\n\n.movie-page__btn--warning:hover {\n  background-color: #d97706;\n}\n\n.movie-page__btn--danger {\n  background-color: var(--error-color);\n  color: var(--text-color);\n}\n\n.movie-page__btn--danger:hover {\n  background-color: #dc2626;\n}\n\n.movie-page__btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.movie-page__stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.movie-page__stats-card {\n  background-color: var(--background-color);\n  border-radius: var(--border-radius);\n  padding: 1rem;\n  text-align: center;\n}\n\n.movie-page__stats-card h3 {\n  font-size: 0.9rem;\n  color: var(--text-color-secondary);\n  margin-bottom: 0.5rem;\n}\n\n.movie-page__stats-card p {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--primary-color);\n}\n\n.movie-page__progress-bar {\n  width: 100%;\n  height: 8px;\n  background-color: var(--background-color);\n  border-radius: var(--border-radius);\n  overflow: hidden;\n  margin-bottom: 1rem;\n}\n\n.movie-page__progress {\n  height: 100%;\n  background-color: var(--primary-color);\n  transition: width var(--transition-speed) ease-in-out;\n}\n\n.movie-page__log-container {\n  margin-top: 1.5rem;\n}\n\n.movie-page__log-list {\n    max-height: 200px;\n    overflow-y: auto;\n    background-color: var(--background-color);\n    border-radius: var(--border-radius);\n    padding: 1rem;\n    font-size: 0.9rem;\n    padding-left: 28px;\n    padding-top: 11px;\n    font-weight: 100;\n}\n\n.movie-page__log-list li {\n  margin-bottom: 0.5rem;\n}\n\n.movie-page__button-group {\n  display: flex;\n  gap: 1rem;\n  margin-top: 1.5rem;\n}\n\n.movie-page__error {\n  color: var(--error-color);\n  background-color: rgba(239, 68, 68, 0.1);\n  padding: 0.75rem;\n  border-radius: var(--border-radius);\n  margin-bottom: 1rem;\n}\n\n.movie-page__success-message {\n  color: var(--success-color);\n  background-color: rgba(16, 185, 129, 0.1);\n  padding: 0.75rem;\n  border-radius: var(--border-radius);\n  margin-bottom: 1rem;\n}\n\n.movie-page__success-text {\n  font-weight: bold;\n}\n\n@media (max-width: 768px) {\n  .movie-page {\n    padding: 1rem;\n  }\n\n  .movie-page__title {\n    font-size: 1.5rem;\n  }\n\n  .movie-page__card-title {\n    font-size: 1.25rem;\n  }\n\n  .movie-page__form-group input,\n  .movie-page__form-group select,\n  .movie-page__btn {\n    font-size: 0.875rem;\n  }\n\n  .movie-page__log-list {\n    max-height: 150px;\n  }\n\n  .movie-page__button-group {\n    flex-direction: column;\n  }\n\n  .movie-page__button-group .movie-page__btn {\n    width: 100%;\n  }\n}\n/* Estilos para SeriesPage */\n.series-page {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem;\n}\n\n.series-page__title {\n  font-size: 2rem;\n  font-weight: 700;\n  margin-bottom: 1.5rem;\n  color: var(--primary-color);\n}\n\n.series-page__card {\n  background-color: var(--surface-color);\n  border-radius: var(--border-radius);\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.series-page__card-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n  color: var(--primary-color);\n}\n\n.series-page__form {\n  margin-bottom: 1rem;\n}\n\n.series-page__form-group {\n  margin-bottom: 1rem;\n}\n\n.series-page__form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  color: var(--text-color-secondary);\n}\n\n.series-page__form-group input,\n.series-page__form-group select {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid var(--surface-color);\n  border-radius: var(--border-radius);\n  background-color: var(--background-color);\n  color: var(--text-color);\n  font-size: 1rem;\n}\n\n.series-page__form-group input:focus,\n.series-page__form-group select:focus {\n  outline: none;\n  border-color: var(--primary-color);\n}\n\n.series-page__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.75rem 1rem;\n  border: none;\n  border-radius: var(--border-radius);\n  cursor: pointer;\n  transition: background-color var(--transition-speed);\n  font-size: 1rem;\n  font-weight: 500;\n}\n\n.series-page__btn svg {\n  margin-right: 0.5rem;\n}\n\n.series-page__btn--primary {\n  background-color: var(--primary-color);\n  color: var(--text-color);\n}\n\n.series-page__btn--primary:hover {\n  background-color: var(--primary-hover);\n}\n\n.series-page__btn--success {\n  background-color: var(--success-color);\n  color: var(--text-color);\n}\n\n.series-page__btn--success:hover {\n  background-color: #0d9488;\n}\n\n.series-page__btn--warning {\n  background-color: var(--warning-color);\n  color: var(--text-color);\n}\n\n.series-page__btn--warning:hover {\n  background-color: #d97706;\n}\n\n.series-page__btn--danger {\n  background-color: var(--error-color);\n  color: var(--text-color);\n}\n\n.series-page__btn--danger:hover {\n  background-color: #dc2626;\n}\n\n.series-page__btn--secondary {\n  background-color: var(--text-color-secondary);\n  color: var(--text-color);\n}\n\n.series-page__btn--secondary:hover {\n  background-color: #6b7280;\n}\n\n.series-page__btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.series-page__stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.series-page__stats-card {\n  background-color: var(--background-color);\n  border-radius: var(--border-radius);\n  padding: 1rem;\n  text-align: center;\n}\n\n.series-page__stats-card h3 {\n  font-size: 0.9rem;\n  color: var(--text-color-secondary);\n  margin-bottom: 0.5rem;\n}\n\n.series-page__stats-card p {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--primary-color);\n}\n\n.series-page__progress-bar {\n  width: 100%;\n  height: 8px;\n  background-color: var(--background-color);\n  border-radius: var(--border-radius);\n  overflow: hidden;\n  margin-bottom: 1rem;\n}\n\n.series-page__progress {\n  height: 100%;\n  background-color: var(--primary-color);\n  transition: width var(--transition-speed) ease-in-out;\n}\n\n.series-page__log-container {\n  margin-top: 1.5rem;\n}\n\n.series-page__log-list {\n  max-height: 200px;\n  overflow-y: auto;\n  background-color: var(--background-color);\n  border-radius: var(--border-radius);\n  padding: 1rem;\n  font-size: 0.9rem;\n}\n\n.series-page__log-list li {\n  margin-bottom: 0.5rem;\n}\n\n.series-page__button-group {\n  display: flex;\n  gap: 1rem;\n  margin-top: 1.5rem;\n}\n\n.series-page__error {\n  color: var(--error-color);\n  background-color: rgba(239, 68, 68, 0.1);\n  padding: 0.75rem;\n  border-radius: var(--border-radius);\n  margin-bottom: 1rem;\n}\n\n.series-page__success-message {\n  color: var(--success-color);\n  background-color: rgba(16, 185, 129, 0.1);\n  padding: 0.75rem;\n  border-radius: var(--border-radius);\n  margin-bottom: 1rem;\n}\n\n.series-page__success-text {\n  font-weight: bold;\n}\n\n.series-page__subtitle {\n  font-size: 1.2rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n  color: var(--primary-color);\n}\n\n.series-page__category-list {\n  list-style-type: none;\n  padding-left: 0;\n  margin-bottom: 1.5rem;\n}\n\n.series-page__category-list li {\n  margin-bottom: 0.5rem;\n  padding: 0.5rem;\n  background-color: var(--background-color);\n  border-radius: var(--border-radius);\n}\n\n@media (max-width: 768px) {\n  .series-page {\n    padding: 1rem;\n  }\n\n  .series-page__title {\n    font-size: 1.5rem;\n  }\n\n  .series-page__card-title {\n    font-size: 1.25rem;\n  }\n\n  .series-page__form-group input,\n  .series-page__form-group select,\n  .series-page__btn {\n    font-size: 0.875rem;\n  }\n\n  .series-page__log-list {\n    max-height: 150px;\n  }\n\n  .series-page__button-group {\n    flex-direction: column;\n  }\n\n  .series-page__button-group .series-page__btn {\n    width: 100%;\n  }\n\n  .series-page__stats-grid {\n    grid-template-columns: 1fr;\n  }\n}\n.tutorial-card {\n  background-color: var(--surface-color);\n  border-radius: var(--border-radius);\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.tutorial-card h3 {\n  color: var(--primary-color);\n  margin-bottom: 1rem;\n}\n\n.tutorial-card ol, .tutorial-card ul {\n  padding-left: 1.5rem;\n  margin-bottom: 1rem;\n}\n\n.tutorial-card li {\n  margin-bottom: 0.5rem;\n}\n\n.copyable-text {\n  background-color: var(--background-color);\n  padding: 0.5rem;\n  border-radius: var(--border-radius);\n  margin: 0.5rem 0;\n  position: relative;\n  font-family: monospace;\n  white-space: pre-wrap;\n  word-break: break-all;\n}\n\n.copy-button {\n  position: absolute;\n  right: 0.5rem;\n  top: 50%;\n  transform: translateY(-50%);\n  background-color: var(--primary-color);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 0.25rem 0.5rem;\n  cursor: pointer;\n  font-size: 0.8rem;\n  display: flex;\n  align-items: center;\n}\n\n.copy-button:hover {\n  background-color: var(--primary-hover);\n}\n\n.copy-button svg {\n  margin-right: 0.25rem;\n}\n.movie-page__category-controls {\n    display: inline-block;\n    justify-content: space-between;\n    margin-bottom: 1rem;\n    margin-left: 60px;\n}\n.movie-page__category-controls .movie-page__btn {\n    padding: 0.5rem 2rem;\n    font-size: 0.9rem;\n    margin-left: 6px;\n}\n\n.movie-page__categories-list {\n    max-height: 100%;\n    overflow-y: auto;\n    border: 1px solid var(--surface-color);\n    border-radius: var(--border-radius);\n    padding: 0.5rem;\n    margin-bottom: 1rem;\n    display: inline-block;\n}\n\n.movie-page__category-item {\n    display: inline-block;\n    align-items: center;\n    margin-left: 49px;\n    padding: 0.5rem;\n    width: 300px;\n    margin-bottom: 12px;\n    background-color: var(--background-color);\n    border-radius: var(--border-radius);\n}\n\n.movie-page__category-item input[type=\"checkbox\"] {\n  margin-right: 0.5rem;\n}\n\n.movie-page__category-item input[type=\"text\"] {\n    flex-grow: 1;\n    margin-right: 0.5rem;\n    background: #101521;\n    padding: 0.50rem;\n    color: #fff;\n    border: none;\n}\n\n.movie-page__category-item span {\n  font-size: 0.8rem;\n  color: var(--text-color-secondary);\n}\n.notification {\n  padding: 10px;\n  margin-bottom: 15px;\n  border-radius: var(--border-radius);\n  text-align: center;\n  font-weight: bold;\n}\n\n.notification.success {\n  background-color: rgba(16, 185, 129, 0.1);\n  color: var(--success-color);\n  border: 1px solid var(--success-color);\n}\n\n.notification.error {\n  background-color: rgba(239, 68, 68, 0.1);\n  color: var(--error-color);\n  border: 1px solid var(--error-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
